import React from "react";

function Status({ status, text }) {
  let statusStyles = "";
  let statusText = text;

  // Set styles and default text based on the status
  switch (status) {
    case "active":
      statusStyles = "bg-[#D1FAE4] text-accent-green-inverted";
      statusText = text || "Active";
      break;
    case "pending":
      statusStyles = "bg-[#f0d3a6] text-[#c08328]";
      statusText = text || "Pending";
      break;
    case "inactive":
    default:
      statusStyles = "bg-[#FCE5E4] text-accent-red-inverted";
      statusText = text || "Inactive";
      break;
  }

  return (
    <div
      className={`${statusStyles} flex  min-h-5 min-w-[100px]  max-w-[200px] items-center justify-center rounded-md px-[2px]`}
    >
      <p className="text-[12px] font-medium leading-[12px] tracking-[-0.1px]">
        {statusText}
      </p>
    </div>
  );
}

export default Status;
